/**
 * 长会话默认只挂载最近 200 条消息，避免 Markdown、表格和附件一次性撑大 DOM。
 * 用户主动向前加载时每次增加 100 条；完整消息仍保留在 SessionSnapshot 中，
 * 所以这只是浏览器渲染窗口，不会裁剪、删除或重新请求服务端数据。
 */
export const INITIAL_MESSAGE_WINDOW = 200;
export const MESSAGE_WINDOW_STEP = 100;

export interface MessageWindow<T> {
  hiddenCount: number;
  visible: T[];
}

export function sliceMessageWindow<T>(items: T[], limit: number): MessageWindow<T> {
  const safeLimit = Math.max(1, Math.floor(limit));
  const hiddenCount = Math.max(0, items.length - safeLimit);
  return {
    hiddenCount,
    visible: hiddenCount ? items.slice(hiddenCount) : items,
  };
}

export function nextMessageWindowLimit(current: number, total: number): number {
  return Math.min(total, Math.max(INITIAL_MESSAGE_WINDOW, current + MESSAGE_WINDOW_STEP));
}
